import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { Form } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import TaxObligationQuestion from './TaxObligationQuestion';
import ConfirmAllTaxObligation from './ConfirmAllTaxObligation';
import TaxObligationFieldList from './TaxObligationFieldList';
import FocusHOC from '../../../components/FocusHOC';
import IncomeFromBusiness from './IncomeFromBusiness';
import Submit from '../../../components/Submit';
import { onKeyPress } from '../../../utils';

const BusinessTypePage = ({ saveFinanceForm, getBusinessData, decorators, businessId }) => (
  <Form
    onSubmit={(data) => saveFinanceForm(data, businessId)}
    decorators={decorators}
    initialValues={getBusinessData}
    render={({ handleSubmit, values }) => (
      <form onSubmit={handleSubmit} onKeyPress={onKeyPress}>
        <Content>
          {({ financeHeader = '' }) => (
            <div>
              <PageHeading>{financeHeader}</PageHeading>

              <TaxObligationQuestion formFieldValues={values} />

              {values.hasTaxObligation === 'No' && (
                <div>
                  <ConditionalPanel isVisible>
                    <TaxObligationFieldList taxList={values.taxList} values={values} />
                    <ConfirmAllTaxObligation values={values} />
                  </ConditionalPanel>
                </div>
              )}
              <IncomeFromBusiness values={values} />

              <Submit />
            </div>
          )}
        </Content>
      </form>
    )}
  />
);

BusinessTypePage.propTypes = {
  saveFinanceForm: PropTypes.func.isRequired
};

export default FocusHOC(BusinessTypePage);
